import { atom } from 'jotai';

const isFirstLoadMLAtom = atom(true);

export { isFirstLoadMLAtom };
